import React from "react";

const ClientBehavior = ({ formData, handleChange, setActiveTab, errors = {}, onNext }) => {
    return (
        <div id="client-behavior" className="content">
            <div className="row g-3 justify-content-center">

                {/* ================== CLIENT BEHAVIOR ================== */}
                <div className="col-md-12 mb-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Will you describe the client generally as:
                    </small>
                    <div className="form-floating form-floating-outline">
                        <select
                            className={`form-select ${errors.client_general_behavior ? 'is-invalid' : ''}`}
                            name="client_general_behavior"
                            value={formData.client_general_behavior || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select Client Behaviour</option>
                            <option value="Aloof/Withdrawn or Friendly & Outgoing">
                                Aloof/Withdrawn or Friendly & Outgoing
                            </option>
                            <option value="Impulsive & Irritable or Calm & Composed. Suspicious or Trustful">
                                Impulsive & Irritable or Calm & Composed. Suspicious or Trustful
                            </option>
                            <option value="Deceptive or Honest">Deceptive or Honest</option>
                            <option value="Threatening/Intimidating or Calm & Inspirit">
                                Threatening/Intimidating or Calm & Inspirit
                            </option>
                            <option value="Non-adhering to treatment or Follows Doctor's Advice">
                                Non-adhering to treatment or Follows Doctor's Advice
                            </option>
                            <option value="Fear of future aggression">
                                Fear of future aggression
                            </option>
                        </select>
                        <label>Client's General Behavior</label>
                        {errors.client_general_behavior && (
                            <div className="invalid-feedback">{errors.client_general_behavior}</div>
                        )}
                    </div>
                </div>

                {/* ================== IMPULSIVE BEHAVIOR ================== */}
                <div className="col-md-12 mb-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Does the client exhibit impulsive behavior?
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `impulsive-${option}`;
                            return (
                                <div className="form-check form-check-inline" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="impulsive_behavior"
                                        id={inputId}
                                        value={option}
                                        checked={formData.impulsive_behavior === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {errors.impulsive_behavior && (
                        <small className="text-danger d-block text-center mt-2">{errors.impulsive_behavior}</small>
                    )}
                </div>

                {/* ================== IMPULSIVE EXAMPLES (IF YES) ================== */}
                {formData.impulsive_behavior === "Yes" && (
                    <>
                        <div className="col-md-12">
                            <label className="fw-semibold mb-2">
                                If YES, please give three examples:
                            </label>
                        </div>

                        {[1, 2, 3].map((num) => (
                            <div className="col-md-12" key={num}>
                                <div className="form-floating form-floating-outline mb-3">
                                    <input
                                        type="text"
                                        className={`form-control ${errors[`impulsive_example_${num}`] ? 'is-invalid' : ''}`}
                                        name={`impulsive_example_${num}`}
                                        value={formData[`impulsive_example_${num}`] || ""}
                                        onChange={handleChange}
                                        placeholder={`Example ${num}`}
                                    />
                                    <label>{`Example ${num}`}</label>
                                    {errors[`impulsive_example_${num}`] && (
                                        <div className="invalid-feedback">{errors[`impulsive_example_${num}`]}</div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </>
                )}

                {/* ================== SYMPTOMS ================== */}
                <div className="col-md-12 mt-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Symptoms
                    </small>
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control ${errors.symptoms ? 'is-invalid' : ''}`}
                            name="symptoms"
                            value={formData.symptoms || ""}
                            onChange={handleChange}
                            placeholder="Enter symptoms"
                            style={{ height: "100px" }}
                        />
                        <label>Symptoms</label>
                        {errors.symptoms && (
                            <div className="invalid-feedback">{errors.symptoms}</div>
                        )}
                    </div>
                </div>

                {/* ================== EXPECTATIONS ================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Expectations from Rehabilitation Services at The Recovery House
                    </small>
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control ${errors.rehab_expectations ? 'is-invalid' : ''}`}
                            name="rehab_expectations"
                            value={formData.rehab_expectations || ""}
                            onChange={handleChange}
                            placeholder="Expectations"
                            style={{ height: "100px" }}
                        />
                        <label>Expectations</label>
                        {errors.rehab_expectations && (
                            <div className="invalid-feedback">{errors.rehab_expectations}</div>
                        )}
                    </div>
                </div>

                {/* ================== FEAR OF AGGRESSION ================== */}
                <div className="col-md-12 mb-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Do you fear that there will be another sudden episode of violence/aggression by the client?
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `fear_aggression-${option}`;
                            return (
                                <div className="form-check form-check-inline" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="fear_aggression"
                                        id={inputId}
                                        value={option}
                                        checked={formData.fear_aggression === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {errors.fear_aggression && (
                        <small className="text-danger d-block text-center mt-2">{errors.fear_aggression}</small>
                    )}
                </div>

                {/* ================== PSYCHIATRIST NOTE ================== */}
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className="form-control"
                            name="psychiatrist_note"
                            value={formData.psychiatrist_note || ""}
                            onChange={handleChange}
                            placeholder="Note of Psychiatrist"
                            style={{ height: "120px" }}
                        />
                        <label>Note of Psychiatrist at The Recovery House</label>
                    </div>
                </div>

                {/* ================== NAVIGATION BUTTONS ================== */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("aggression-history")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm btn-next ms-2 w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientBehavior;